import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
import { IUsers } from '../database';
@Injectable()
export class FinanceService {

    private _getBillUrl = APIURL+'Users/getUsersOpenBill';
    private _getAllBillUrl = APIURL+'Users/getUsersBuill';
    private _setBillConfiUrl = APIURL+'Users/setUserConfirmed';
    private _setBillAmountUrl = APIURL+'Users/getUsersBillAmount';
    private _getBillHTMLUrl = APIURL+'Users/viewBill';
    private currentUser :IUsers ; 
    constructor(private _http: Http) { 
           console.log( this.currentUser);
    }
    getBillViewData(BillId){
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
        let formData:FormData = new FormData();
         formData.append('BillId', BillId);
        return this._http.post(this._getBillHTMLUrl,formData )
                            .map((response: any) =>response )
    }
    getUserBill(): any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
        let formData:FormData = new FormData();
         formData.append('UserId', this.currentUser.UserId+"");
         formData.append('userTypeId', this.currentUser.userTypeId+"");
        return this._http.post(this._getAllBillUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    getUserBillById(userId):any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
        let formData:FormData = new FormData();
         formData.append('UserId', userId+"");
         formData.append('userTypeId', this.currentUser.userTypeId+"");
        return this._http.post(this._getBillUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    getUserBillAmount(userId): any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
        let formData:FormData = new FormData();
         formData.append('UserId', userId+"");
        return this._http.post(this._setBillAmountUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    confirmUserBill(billInfo): any{
        this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
        let formData:FormData = new FormData();
         formData.append('UserId', this.currentUser.UserId+"");
         formData.append('billId', billInfo.PayRequestId);
        return this._http.post(this._setBillConfiUrl,formData )
                            .map((response: Response) => response.json().data)
    }
     private handleError(error: Response) {
        
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/finance.service.ts